module.exports = __webpack_public_path__ + "static/media/savio24.d00bebc2.jpg";